import React from 'react';
import PropTypes from 'prop-types';
import styled, { createGlobalStyle } from 'styled-components';
import Grid from '@ntuctech/devex-tangram/Grid';
import Box from '@ntuctech/devex-tangram/Box';
import Typography from '@ntuctech/devex-tangram/Typography';
import _get from 'lodash.get';

import { useAuth0 } from '../../Auth0Provider';
import MainGirlDesktop from '../Illust/MainGirlDesktop';
import MainGirlMobile from '../Illust/MainGirlMobile';
import NoScript from '../NoScript';
import {
  SERVICE_LINK,
  COLOR_CODE_GRAD,
  LINK_ID_GRADIENT_BASE,
  COLOR_CODE_SHIRT,
  CLIENT_COLOR_NAMES,
  LOGO_COMP_NAME,
  LinkpassLogo,
  MyNtucLogo,
} from '../../../constants/clients';
import { BREAKPOINT_BELOW_XS, BREAKPOINT_BELOW_M } from '../../../constants';

const GlobalStyle = createGlobalStyle`
  html, body, #__next {
    height:100%;
    background-color: #ffffff;
  }

  @keyframes onAutoFillStart {
  }

  input:-webkit-autofill {
    animation-name: onAutoFillStart;
  }

  .SSOPage__input-number-reset {
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    input[type='number'] {
      -moz-appearance: textfield;
    }
  }

  /* lato-regular - latin-ext_latin */
  @font-face {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('https://media.nedigital.sg/nedigital/files/daec682d-3287-405a-aa79-96223c4b497f/lato-v16-latin-ext_latin-regular.eot'); /* IE9 Compat Modes */
    src: local('Lato Regular'), local('Lato-Regular'),
         url('https://media.nedigital.sg/nedigital/files/daec682d-3287-405a-aa79-96223c4b497f/lato-v16-latin-ext_latin-regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
         url('https://media.nedigital.sg/nedigital/files/9cf5fe64-979a-46af-a184-af1cd2c77395/lato-v16-latin-ext_latin-regular.woff2') format('woff2'), /* Super Modern Browsers */
         url('https://media.nedigital.sg/nedigital/files/9fc0d407-b429-4c2d-9790-860be8ea8fa9/lato-v16-latin-ext_latin-regular.woff') format('woff'), /* Modern Browsers */
         url('https://media.nedigital.sg/nedigital/files/3a1f5374-6aba-42e9-936c-e11e05682f7d/lato-v16-latin-ext_latin-regular.ttf') format('truetype'), /* Safari, Android, iOS */
         url('https://media.nedigital.sg/nedigital/files/f38150ff-ee7f-44f8-9837-9f811f0ff1d6/lato-v16-latin-ext_latin-regular.svg#Lato') format('svg'); /* Legacy iOS */
  }
  /* lato-700 - latin-ext_latin */
  @font-face {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url('https://media.nedigital.sg/nedigital/files/f8cbf2f4-4d0c-4989-af28-4c0c07c03925/lato-v16-latin-ext_latin-700.eot'); /* IE9 Compat Modes */
    src: local('Lato Bold'), local('Lato-Bold'),
         url('https://media.nedigital.sg/nedigital/files/f8cbf2f4-4d0c-4989-af28-4c0c07c03925/lato-v16-latin-ext_latin-700.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
         url('https://media.nedigital.sg/nedigital/files/062804f9-65e6-46df-b4a3-69d515ee444c/lato-v16-latin-ext_latin-700.woff2') format('woff2'), /* Super Modern Browsers */
         url('https://media.nedigital.sg/nedigital/files/67fb7ecc-87c0-4613-aa21-892f5d5678cb/lato-v16-latin-ext_latin-700.woff') format('woff'), /* Modern Browsers */
         url('https://media.nedigital.sg/nedigital/files/0270b03c-3d43-4e17-9402-8d3a1bfab940/lato-v16-latin-ext_latin-700.ttf') format('truetype'), /* Safari, Android, iOS */
         url('https://media.nedigital.sg/nedigital/files/10ccbb7c-f796-4689-a0f6-9bec2c42fc8d/lato-v16-latin-ext_latin-700.svg#Lato') format('svg'); /* Legacy iOS */
  }
  /* lato-900 - latin-ext_latin */
  @font-face {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 900;
    font-display: swap;
    src: url('https://media.nedigital.sg/nedigital/files/686e1a69-f900-404f-8011-c7cc8768717e/lato-v16-latin-ext_latin-900.eot'); /* IE9 Compat Modes */
    src: local('Lato Black'), local('Lato-Black'),
         url('https://media.nedigital.sg/nedigital/files/686e1a69-f900-404f-8011-c7cc8768717e/lato-v16-latin-ext_latin-900.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
         url('https://media.nedigital.sg/nedigital/files/72173d62-62f2-4965-85d2-98262c76f0af/lato-v16-latin-ext_latin-900.woff2') format('woff2'), /* Super Modern Browsers */
         url('https://media.nedigital.sg/nedigital/files/ec8552d4-383a-4dde-8e47-07adcce35f9a/lato-v16-latin-ext_latin-900.woff') format('woff'), /* Modern Browsers */
         url('https://media.nedigital.sg/nedigital/files/c6acdf36-3c71-4a1f-8587-be2067ed1f30/lato-v16-latin-ext_latin-900.ttf') format('truetype'), /* Safari, Android, iOS */
         url('https://media.nedigital.sg/nedigital/files/5c3ed274-1d25-43af-a4c4-83f4bf977a08/lato-v16-latin-ext_latin-900.svg#Lato') format('svg'); /* Legacy iOS */
  }
`;

const ILLUST_GRAD = (props) =>
  `linear-gradient(110.22deg, ${props.color} 0%, ${LINK_ID_GRADIENT_BASE} 100%)`;

const FullPageGridContainer = styled(Grid)`
  padding: 0;
  min-height: 100%;

  @media (${BREAKPOINT_BELOW_M}) {
    flex-direction: column;
  }
`;

const IllustGrid = styled(Grid)`
  background: ${ILLUST_GRAD};
  position: relative;
  overflow: hidden;

  & .MainIllustration {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  & .SSOPage__illust-mobile {
    height: 100%;
    width: 21.5rem;
    margin: 0 auto;
    position: relative;
  }
  & .SSOPage__illust-mobile .MainIllustration {
    max-width: 23.5rem;
    width: 100%;
  }

  & .SSOPage__illust-desktop {
    height: 100%;
  }
  & .SSOPage__illust-desktop .MainIllustration {
    max-width: 30.3125rem;
    width: 100%;
  }

  @media (${BREAKPOINT_BELOW_M}) {
    height: 7.5rem;

    ${LinkpassLogo},
    ${MyNtucLogo} {
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      width: 5.625rem;
    }

    ${LinkpassLogo} {
      height: 1.5rem;
    }

    ${MyNtucLogo} {
      height: 2.5rem;
    }
  }

  @media (${BREAKPOINT_BELOW_XS}) {
    & .SSOPage__illust-mobile {
      width: 100%;
      padding: 0 0.25rem;
    }

    ${LinkpassLogo},
    ${MyNtucLogo} {
      left: 1rem;
    }
  }
`;

const MainContent = styled.div`
  width: 100%;
  margin: 0 auto;
  margin-top: 7rem;
  margin-bottom: 3rem;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  will-change: width;
  transition: width ease 0.3s;
  position: relative;

  & .SSOPage__header {
    text-align: left;
  }

  & .SSOPage__form-desc p {
    text-align: left;
  }

  & .SSOPage__tag {
    text-align: left;
  }
  & .SSOPage__header-with-action {
    margin-left: 0;
  }

  @media (${BREAKPOINT_BELOW_M}) {
    width: 21.5rem;
    margin-top: 1.5rem;

    & .SSOPage__header-with-action {
      margin-left: 3.5rem;
    }
  }

  @media (${BREAKPOINT_BELOW_XS}) {
    width: 100%;
    padding: 0 1rem;
  }
`;

const Endorsement = styled(Box)`
  display: flex;
  align-items: center;
`;

const EndorsementLogo = styled.div`
  background-image: url('https://media.nedigital.sg/linkpass/files/3364f6ff-72e1-4c64-9e2c-8b10746c04cd/Link_Logo_RGB.svg');
  background-size: 100%;
  background-position: center;
  background-repeat: no-repeat;
  width: 3.25rem;
  height: 1rem;
  display: inline-block;
  margin-left: 0.25rem;
`;

const LayoutNew = ({ children }) => {
  const { userContext } = useAuth0();

  const LogoCompMap = { LinkpassLogo, MyNtucLogo };

  const themeColorName = React.useMemo(
    () => _get(userContext, 'clientBasedUi.themeColorName', CLIENT_COLOR_NAMES.link),
    [userContext],
  );

  const LogoComp = React.useMemo(() => {
    const logoName = _get(userContext, 'clientBasedUi.customLogo', SERVICE_LINK);
    return LogoCompMap[LOGO_COMP_NAME[logoName]];
  }, [userContext]);

  return (
    <>
      <GlobalStyle />
      <FullPageGridContainer container data-testid="SSOLayout">
        <IllustGrid
          color={COLOR_CODE_GRAD[themeColorName]}
          m={5}
          l={4}
          data-testid="LinkIdIllustration"
        >
          <div className="ndsHidden-m-up SSOPage__illust-mobile">
            <LogoComp data-testid="AppLogoMobile" className="AppLogoMobile" />
            <MainGirlMobile color={COLOR_CODE_SHIRT[themeColorName]} />
          </div>

          <div className="ndsHidden-s-down SSOPage__illust-desktop">
            <LogoComp data-testid="AppLogoDesktop" />
            <MainGirlDesktop color={COLOR_CODE_SHIRT[themeColorName]} />
          </div>
        </IllustGrid>
        <Grid m={7} l={8}>
          <MainContent>
            <NoScript />
            {children}
            <Endorsement mt={6} data-testid="EndorsementLine">
              <Typography variant="body4">powered by</Typography>
              <EndorsementLogo />
            </Endorsement>
          </MainContent>
        </Grid>
      </FullPageGridContainer>
    </>
  );
};

LayoutNew.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LayoutNew;
